import React from 'react';

import { LazyTeamCalendars, CALENDAR_CONTEXT } from '@confluence/team-calendar';

export function EmbeddedMultipleCalendarRoute() {
	return <LazyTeamCalendars calendarContext={CALENDAR_CONTEXT.EMBEDDED_MULTIPLE_CALENDARS} />;
}

EmbeddedMultipleCalendarRoute.NAVIGATION_PARAMS = ({ spaceKey }) => ({
	Screen: {
		screenEvent: {
			name: 'embeddedMultipleCalendarsScreen',
			id: spaceKey,
		},
		pageState: { spaceKey },
	},

	MainLayout: {
		enableNavigation: false,
		spaceKey,
	},
});
